import { Outlet } from "react-router-dom";

export const MobileOnlyLayout = () => {
  return (
    <div className="MobileOnlyLayout relative mx-auto flex min-h-dvh flex-col desk:w-full desk:border-0 sm:w-[390px] sm:border">
      <Outlet />
    </div>
  );
};
